namespace $.$$ {

	$mol_style_define( $shm_hitalama_map_widget_float_form2, {
		Form_workspace: {
			width: '100%',
			maxWidth: '100%',
			height: '100%',
			minWidth: 0,
			minHeight: 0,
			overflow: 'auto',
			align: { self: 'stretch' },
		},
		Form: {
			width: '100%',
			maxWidth: '100%',
			minWidth: 0,
			align: { self: 'stretch' },
		},
		Relation_panel: {
			width: '100%',
			maxWidth: '100%',
			minWidth: 0,
			minHeight: 0,
			overflow: 'hidden',
			align: { self: 'stretch' },
			background: { color: $mol_theme.back },
			border: { left: { width: '1px', style: 'solid', color: $mol_theme.line } },
		},
		Relation_form: {
			width: '100%',
			maxWidth: '100%',
			height: '100%',
			minWidth: 0,
			minHeight: 0,
			align: { self: 'stretch' },
		},
	} )

}
